import { FC } from "react";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { MasterPipelinesContent } from "./MasterPipelinesContent";
import { PageNoPermisson } from "../general/PageNoPermission";
import useDynamicTab from "../../../hooks/useDynamicTab";
import { useGeneralStore } from "../../../stores/General";
import MasterLogLeadTable from "./MasterLogLeadTable";

const MasterPipelines: FC = () => {
    const { settings } = useSettingsStore()
    useDynamicTab({ title: `${settings.pipeline_title} | CRM WooBlazz` });
    const { isShowFormLogLead } = useGeneralStore()


    const renderContent = () => {
        if (settings.feature_pipeline && !isShowFormLogLead) {
            return <MasterPipelinesContent />
        } else if (isShowFormLogLead) {
            return <MasterLogLeadTable />
        }
        return <PageNoPermisson title={settings.pipeline_title} />
    }

    return (
        <>
            {renderContent()}
        </>
    )
}

export { MasterPipelines }